import React from "react";
import "./Form.css";
import FormBio from "./FormBio";
import FormContact from "./FormContact";
import FormProfile from "./FormProfile";
import FormLeftContainer from "./FormLeftContainer";
import FormRightContainer from "./FormRightContainer";
import AddButton from "./element/AddButton";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";

function Form({ resume, updateData, updateContactIcon, addData, removeData }) {
  function handleAdd() {
    addData({ category: "contact" });
  }
  return (
    <>
      <div className="form-container max-h-[70rem] xl:w-[480px] 2xl:w-auto xl:block bg-white py-6 px-8 xl:px-10 2xl:px-12 overflow-y-scroll text-sm flex flex-wrap">
        {" "}
        <Tabs>
          <TabList>
            <Tab>General Info</Tab>
            <Tab>Left Column</Tab>
            <Tab>Right Column</Tab>
          </TabList>

          <TabPanel>
            <FormBio bio={resume.bio} updateData={updateData} />
            <div className="pb-4">
              <div className="text-base font-semibold pb-2">Contact</div>
              <div className="">
                {resume.contact.map((contact, index) => {
                  return (
                    <div className="flex justify-between gap-4">
                      {" "}
                      <FormContact
                        key={contact.id}
                        id={index}
                        contact={contact}
                        updateData={updateData}
                        updateContactIcon={updateContactIcon}
                        addData={addData}
                        removeData={removeData}
                      />
                    </div>
                  );
                })}
              </div>

              <AddButton handleAdd={handleAdd} text={"+ contact item"} />
            </div>
            <div className="pb-4">
              <div className="text-base font-semibold pb-2">Profile</div>
              <div className="flex">
                <FormProfile profile={resume.profile} updateData={updateData} />
              </div>
            </div>
          </TabPanel>
          <TabPanel>
            <div className="form-left-container ">
              <FormLeftContainer
                contents={resume.leftContents}
                updateData={updateData}
                addData={addData}
                removeData={removeData}
              />
            </div>
          </TabPanel>
          <TabPanel>
            {" "}
            <div className="form-right-container ">
              <FormRightContainer
                contents={resume.rightContents}
                updateData={updateData}
                addData={addData}
                removeData={removeData}
              />
            </div>
          </TabPanel>
        </Tabs>
      </div>
    </>
  );
}

export default Form;
